import { IDropdownOption } from "@fluentui/react/lib/Dropdown";
import React, { useEffect } from "react";
import { fetchTransportUnits } from "../../../../../redux/actions/catalog/catalog";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { mapIDescriptionToDropDownOptions } from "../../../../../utils";
import { ControlledDropdown } from "../../../../common/selectors/controller/controlledSelector";
import { IBaseSelectorProps } from "../IBaseSelectorProps";

export const TransportUnitSelector: React.FC<IBaseSelectorProps> = ({
    onChange,
    selectedKey,
    propertyName,
    title,
    disabled,
    isRequired,
    control,
    rules,
}) => {
    const { data, loading } = useAppSelector((store) => store.catalog.transportUnits);
    const dispatch = useAppDispatch();

    useEffect(() => {
        data.length === 0 && dispatch(fetchTransportUnits());
    }, [dispatch, data]);

    const customOnChange = (_event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, _index?: number) => {
        onChange(option, propertyName);
    };
    return (
        <ControlledDropdown
            required={isRequired}
            options={mapIDescriptionToDropDownOptions(data)}
            label={title}
            control={control}
            name={propertyName}
            rules={rules}
            disabled={loading || disabled}
            onChange={customOnChange}
            selectedKey={selectedKey}
        />
    );
};
